import * as routeNames from 'constants/routeNames';

// NOTE: we keep a separate route for Login in onboarding because of the back button
const doLoginFlow = () => ({
  name: routeNames.LOGIN,
  params: { hasBackButton: true },
});

export default doLoginFlow;
